import { useServiceSettings } from 'contexts/serviceSettings';
import { useIntl } from 'react-intl';

export const useTranslations = () => {
  const { dexfSettings } = useServiceSettings();
  const { formatMessage } = useIntl();

  const unit = dexfSettings?.localisation.useMetricMeasures
    ? formatMessage({ id: 'storageone.cm' })
    : formatMessage({ id: 'storageone.inches' });

  return {
    unit,
    useMetric: dexfSettings?.localisation.useMetricMeasures
  };
};
